import React from 'react';
import styled from 'styled-components';
import { IconLink, IconFacebook, IconTwitter, spacer20, spacer32, spacer40, white } from '@spotify-internal/encore-web';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { Link } from './Link';
import { withoutProps } from '../utils';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var InlineShareButtons = styled.div.withConfig({
  displayName: "ShareButtons__InlineShareButtons",
  componentId: "sc-71gbth-0"
})(["padding-bottom:", ";color:", ";a:focus:not(:disabled){outline:1px auto -webkit-focus-ring-color;}"], spacer40, function (_ref) {
  var theme = _ref.theme;
  return theme.cta.text;
});
var SocialButton = styled(withoutProps(Link, 'textColor')).withConfig({
  displayName: "ShareButtons__SocialButton",
  componentId: "sc-71gbth-1"
})(["padding-right:", ";:last-of-type{padding-right:0;}svg{color:", ";height:", ";&:hover{color:", ";}}"], spacer20, function (_ref2) {
  var textColor = _ref2.textColor;
  return textColor ? textColor : white;
}, spacer32, function (_ref3) {
  var textColor = _ref3.textColor;
  return textColor ? hexToRgba(textColor, 0.75) : hexToRgba(white, 0.75);
});

var loadScript = function loadScript(hasWindow) {
  return new Promise(function (resolve, reject) {
    if (!hasWindow || !process.env.REACT_APP_ADDTHIS_ID) {
      resolve();
      return;
    } // @ts-ignore


    if (window.addthis) {
      // @ts-ignore
      resolve(window.addthis);
      return;
    }

    var firstScript = document.getElementsByTagName('script')[0];
    var newScript = document.createElement('script');
    newScript.onerror = reject;

    newScript.onload = function () {
      // @ts-ignore
      resolve(window.addthis);
    };

    newScript.async = true;
    newScript.src = "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5f2451e75305abf2";

    if (firstScript) {
      // @ts-ignore
      firstScript.parentNode.insertBefore(newScript, firstScript);
    }
  });
}; // add share links to video module and article module


function loadAddThis() {
  var hasWindow = true;
  var singleton;

  if (!singleton) {
    singleton = loadScript(hasWindow);
  }

  return singleton;
}

export var ShareButtonsComponent = function ShareButtonsComponent(_ref4) {
  var _ref4$textColor = _ref4.textColor,
      textColor = _ref4$textColor === void 0 ? '' : _ref4$textColor;
  var t = useT();
  React.useEffect(function () {
    loadAddThis();
  }, []);
  var TRACK_CAT = 'frodor_share';

  function copyToClipboard() {
    navigator.clipboard.writeText(window.location.href);
  }

  return /*#__PURE__*/_jsxs(InlineShareButtons, {
    className: "addthis_toolbox",
    children: [/*#__PURE__*/_jsx(SocialButton, {
      external: true,
      className: "addthis_button_facebook",
      track: [TRACK_CAT, 'facebook'],
      textColor: textColor,
      href: "/",
      children: /*#__PURE__*/_jsx(IconFacebook, {
        "aria-label": t('FRODOR_SHARE_FACEBOOK', 'Share on Facebook', 'Link to share current page on Facebook')
      })
    }), /*#__PURE__*/_jsx(SocialButton, {
      external: true,
      className: "addthis_button_twitter",
      track: [TRACK_CAT, 'twitter'],
      textColor: textColor,
      href: "/",
      children: /*#__PURE__*/_jsx(IconTwitter, {
        "aria-label": t('FRODOR_SHARE_TWITTER', 'Share on Twitter', 'Link to share current page on Twitter')
      })
    }), /*#__PURE__*/_jsx(SocialButton, {
      external: true,
      track: [TRACK_CAT, 'link_copy'],
      textColor: textColor,
      children: /*#__PURE__*/_jsx(IconLink, {
        onClick: copyToClipboard,
        "aria-label": t('FRODOR_SHARE_COPY_LINK', 'Copy link to clipboard', 'Link to copy current page URL to clipboard for sharing')
      })
    })]
  });
};